import { Navigate, Route, Routes } from 'react-router-dom'
import { AnonymousRoutesLazy, AuthenticatedRoutesLazy } from '@/Routes'
import { useAuth } from '@/auth'
import { ExternalURLRoute } from '@/external'
import { ToteLandingScreenLazy } from '@/screens'
import { AdminRootLazy } from '@/screens/Admin'
import { XLMoteLandingScreenLazy } from '@/screens/MoteLanding/XLMoteLandingScreen.lazy'
import { routeExternalURLMapping } from '@mote/helpers'
import { useZendeskWidget } from '@mote/helpers/hooks/business/useZendeskWidget'

export const WebRouting = () => {
  useZendeskWidget()

  const auth = useAuth()

  const externalRoutes = Object.entries(routeExternalURLMapping).map(
    ([internalPath, externalURL]) => (
      <Route
        key={internalPath}
        path={internalPath}
        element={<ExternalURLRoute externalURL={externalURL} />}
      />
    )
  )

  const criticalRoutes = (
    <>
      {/*TODO: Split routes below for anonymous and authenticated*/}
      <Route path='m/:moteId' element={<XLMoteLandingScreenLazy />} />
      <Route path='t/:toteId' element={<ToteLandingScreenLazy />} />
      {/*TODO: Split routes above for anonymous and authenticated*/}
    </>
  )

  if (!auth.isAuthenticated) {
    return (
      <Routes>
        {criticalRoutes}
        {externalRoutes}
        <Route path='*' element={<AnonymousRoutesLazy />} />
      </Routes>
    )
  }

  return (
    <Routes>
      {criticalRoutes}
      {externalRoutes}
      <Route path='admin/*' element={<AdminRootLazy />} />
      <Route
        //SUPPORT FOR REDIRECT FROM EXTENSION - Popup.jsx:194
        //REDIRECT SUPPORT FOR OLD PATHS (EMAILS/ZENDESK/etc.)
        path='account/activity'
        element={<Navigate to={'/activity'} replace />}
      />
      <Route
        //REDIRECT SUPPORT FOR OLD PATHS (EMAILS/ZENDESK/etc.)
        path='account/users'
        element={<Navigate to={'/my-school/manage-users'} replace />}
      />
      <Route
        //REDIRECT SUPPORT FOR OLD PATHS (EMAILS/ZENDESK/etc.)
        path='account/analytics'
        element={<Navigate to={'/my-school/admin-insights'} replace />}
      />
      <Route
        //SUPPORT FOR REDIRECT FROM EXTENSION - Popup.jsx:194
        path='account/loops'
        element={<Navigate to={'/my-loops'} replace />}
      />
      <Route path='*' element={<AuthenticatedRoutesLazy />} />
    </Routes>
  )
}
